module.exports = __webpack_public_path__ + "static/branch-mobile-b9356a10f631e0964df1c53c70a1fee9.svg";